// extracted by mini-css-extract-plugin
module.exports = {"video-item":"video-player_video-item__3Blmd","controls":"video-player_controls__13zj6","status":"video-player_status__2VICT"};